













































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
// import { addWatermarker } from '../../utils/waterMarker'
import { SubContentRenderMap, SubContentRenderMap2 } from './subContents'
import { Question, SubContent } from './types'
import { renderFormula, transform } from './utils'

@Component
export default class QRender extends Vue {
  public get user() {
    return this.$store.state.user
  }
  // 显示作答说明
  private get showDescription() {
    return this.qWrapper && this.qWrapper.id && this.qWrapper.description.length > 0
  }

  // 显示英语听力原文
  private get showContentDesc() {
    return (
      this.qWrapper &&
      this.qWrapper.id &&
      this.qWrapper.content_desc &&
      this.qWrapper.content_desc.length > 0
    )
  }

  // 处理题目中的公式
  private get qWrapper() {
    let ret = transform(this.q)
    return ret
  }

  // 显示大题干  大题干存在 或者 题型是复合题 或者 子题数量>=2）
  private get showContent() {
    return (
      this.qWrapper &&
      this.qWrapper.id &&
      (this.qWrapper.content.length > 0 ||
        this.qWrapper.complex == 1 ||
        this.qWrapper.sub_contents.length > 1)
    )
  }

  private get complexLogic() {
    return (
      this.qWrapper &&
      this.qWrapper.id &&
      (this.qWrapper.complex == 1 || this.qWrapper.sub_contents.length > 1)
    )
  }

  /**
   * subContentshowLevelOneIndex
   * 是否要在子题上添加一级编号
   */
  private get subContentshowLevelOneIndex() {
    if (!this.showDescription && !this.showContent) {
      return true
    }
    return false
  }

  @Prop() public q!: Question
  @Prop() public startIndex!: number
  @Prop() public showAnalysis!: boolean
  @Prop() public inShoppingCart!: boolean
  @Prop() public hover!: boolean
  @Prop() public showTitle!: boolean

  @Prop({
    default() {
      return true
    }
  })
  public haveShopCart!: boolean
  @Prop({
    default() {
      return true
    }
  })
  public showTools!: boolean
  @Prop({
    default() {
      return true
    }
  })
  public showWaterMaker!: boolean

  @Prop({
    default() {
      return false
    }
  })
  // 是否显示试卷名
  public showPaperName!: boolean

  public mounted() {
    if (this.showWaterMaker) {
      // this.renderWatermarker()
    }
  }

  public getCmp(sub: SubContent, q: Question) {
    // 尝试匹配大题干题型
    for (let item of SubContentRenderMap2) {
      if (Array.isArray(item.question_type)) {
        if (item.question_type.includes(q.question_type)) {
          return item.component
        }
      } else if (item.question_type === q.question_type) {
        return item.component
      }
    }

    // 再尝试子题题型
    for (let item of SubContentRenderMap) {
      if (Array.isArray(item.base_question_type)) {
        if (item.base_question_type.includes(sub.base_question_type)) {
          return item.component
        }
      } else if (item.base_question_type == sub.base_question_type) {
        return item.component
      }
    }
    throw new Error('未实现的基础题目类型：' + sub.base_question_type)
  }

  public clickShowAnalysis() {
    this.$emit('showAnalysis', !this.showAnalysis)
  }

  public clickAddCart() {
    this.$emit('addCart', !this.inShoppingCart)
  }
  // 渲染水印
  // public renderWatermarker() {
  //   let elements = document.querySelectorAll('.qr__root')
  //   const text = (this.user && this.user.name) || ''
  //   for (let i = 0; i < elements.length; i++) {
  //     addWatermarker(elements[i], `17题库 ${text}`)
  //   }
  // }

  private contentWrapper(content: string) {
    let str = this.q.origin_info
      ? `<a href="javascript: 0;" class="q-paper-info">（${this.q.origin_info}）</a>`
      : ''

    if (this.startIndex < 0) {
      return !this.showDescription && this.showContent ? str + content : content
    }
    if (!this.showDescription && this.showContent) {
      return '<span class="q-number-index">' + (this.startIndex + 1) + '、</span>' + str + content
    }
    return !this.showDescription && this.showContent ? str + content : content
  }

  private descriptionWrapper(description: string) {
    let str = this.q.origin_info
      ? `<a href="javascript: 0;" class="q-paper-info">（${this.q.origin_info}）</a>`
      : ''

    if (this.startIndex < 0) return description ? str + description : description
    if (this.showDescription) {
      return (
        '<span class="q-number-index">' + (this.startIndex + 1) + '、</span>' + str + description
      )
    }
    return str + description
  }

  // TODO: 如果访问不稳定，替换本地MathJax版本
  @Watch('q', { immediate: true })
  private qChange() {
    setTimeout(() => {
      renderFormula(this.$el)
    })
  }

  @Watch('showAnalysis')
  private onShowAnalysisChange() {
    if (!this.showAnalysis) return
    this.qChange()
  }
}
